import React from 'react';
import { string, shape, arrayOf, func } from 'prop-types';

import { Button } from '@andes/button';

import { setCookie } from '../../../lib/cookies';

const namespace = 'ui-search-rescue';

/**
 * ActionsRescue Component
 *
 * Este componente renderiza una lista de acciones, que pueden ser botones o enlaces.
 *
 * @component
 * @param {Object} props - Props del componente.
 * @param {Array} props.actions - Lista de acciones a renderizar. Cada acción debe tener la estructura:
 *   - `type` {string}: Tipo de la acción, puede ser 'button', 'button_self' o 'link'.
 *   - `target` {string}: URL asociada con la acción.
 *   - `label` {Object}: Objeto que contiene el texto de la acción.
 *     - `text` {string}: Texto que se mostrará en el botón o enlace.
 * @param {Function|null} [props.actionButton] - Callback que se ejecuta cuando se activa una acción de tipo botón.
 *
 * @returns {JSX.Element|null} Un fragmento con las acciones renderizadas o `null` si no hay acciones.
 */
const ActionsRescue = ({ actions: initialActions = [], actionButton = null }) => {
  const actions = initialActions || [];

  const Actions = actions.map((action) => {
    if (['button', 'button_self'].includes(action.type)) {
      return (
        <Button
          key={action.label.text}
          className={`${namespace}__button`}
          href={action.target}
          hierarchy="loud"
          onClick={() => {
            setCookie('pr_categ', 'userhide', { 'max-age': 5184000 });

            if (typeof actionButton === 'function') {
              actionButton(action?.onClick, action);
            }
          }}
        >
          {action.label.text}
        </Button>
      );
    }

    if (action.type === 'link') {
      return (
        <a
          key={action.label.text}
          className={`${namespace}__link--decline`}
          href={action.target}
          target="_blank"
          rel="noreferrer"
        >
          {action.label.text}
        </a>
      );
    }

    return null;
  });

  return Actions;
};

ActionsRescue.propTypes = {
  actionButton: func,
  actions: arrayOf(
    shape({
      type: string,
      target: string,
      label: shape({
        text: string,
      }),
    }),
  ).isRequired,
};

export default ActionsRescue;
